<!-- NumberLineMarker.vue -->
<template>
  <div
    v-if="value"
    class="tw-absolute"
    :class="positionClass"
    :style="{ color, left }"
    @click="onClick"
  >
    <div v-if="!isTop">
      <i class="fa fa-caret-up" />
    </div>
    <div
      ref="label"
    >
      <div
        :class="[
          position === 'top' ? '-tw-rotate-[20deg]': 'tw-rotate-[20deg]',
          'tw-origin-left', 'tw-whitespace-nowrap'
        ]"
      >
        <span
          v-if="showValue"
          class="tw-font-bold"
        >
          {{ value.toFixed(0) }}:
        </span>
        <span class="tw-font-bold">{{ clippedLabel }}</span>
      </div>
    </div>
    <div v-if="isTop">
      <i class="fa fa-caret-down" />
    </div>
  </div>
</template>


<script>
export default {
  name: 'NumberLineMarker',
  components: { /* No subcomponents for now */ },
  props: {
    label: {
      type: String,
      required: true,
    },
    maxLength: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      default: '#000',
    },
    backgroundColor: {
      type: String,
      default: '#fff',
    },
    value: {
      type: Number,
      required: true,
    },
    position: {
      type: String,
      default: 'bottom',
    },
    showValue: {
      type: Boolean,
      default: true,
    },
    min: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    shift: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      /* Local variables can be defined here if needed */
    };
  },
  computed: {
    // Creates a new property
    // Updates when any dependent property changes
    isTop() {
      return this.position === 'top';
    },
    positionClass() {
      return `tw-${(this.isTop ? 'bottom' : 'top')}-full`;
    },
    left() {
      const delta = this.value - this.min;
      const range = this.max - this.min;
      return `${(delta / range) * 100}%`;
    },
    clippedLabel() {
      if (this.label.length > this.maxLength) {
        return this.label.slice(0, this.maxLength) + '...';
      }

      return this.label;
    },
  },
  watch: {
    // Watches an existing property
    // Only runs when the watched property changes
  },
  created() {},
  methods: {
    onClick() {
      this.$emit('markerClick', {
        label: this.label,
        value: this.value,
      });
    },
  },
};
</script>


<style scoped>

</style>
